var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list-input-text',{attrs:{"type":"text","placeholder":"次に読む本を選ぶ","get":_vm.get,"set":_vm.set}})}
var staticRenderFns = []

export { render, staticRenderFns }